import { decamelizeKeys } from '../../lib';
import { getBackVersion } from '../../config';
import {
    NewRentalBillingDiscriminationSnapshot,
    RentalBillingDiscriminationSnapshot,
} from '../../models/RentalPayment';
import api from '../api';

const createBillingDiscrimination = (
    billingId: string,
    contractId: string,
    discrimination: NewRentalBillingDiscriminationSnapshot
): Promise<RentalBillingDiscriminationSnapshot> =>
    api.request<RentalBillingDiscriminationSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/agent/rental/contracts_rental/${contractId}/billings/${billingId}/billing_discriminations`,
        data: decamelizeKeys(discrimination),
    });

const updateBillingDiscrimination = (
    key: string,
    billingId: string,
    contractId: string,
    discrimination: NewRentalBillingDiscriminationSnapshot
): Promise<RentalBillingDiscriminationSnapshot> =>
    api.request<RentalBillingDiscriminationSnapshot>({
        method: 'PATCH',
        url: `${getBackVersion()}/agent/rental/contracts_rental/${contractId}/billings/${billingId}/billing_discriminations/${key}`,
        data: decamelizeKeys(discrimination),
    });

const deleteBillingDiscrimination = (
    key: string,
    billingId: string,
    contractId: string
): Promise<boolean> =>
    api.request<boolean>({
        method: 'DELETE',
        url: `${getBackVersion()}/agent/rental/contracts_rental/${contractId}/billings/${billingId}/billing_discriminations/${key}`,
    });

export {
    createBillingDiscrimination,
    updateBillingDiscrimination,
    deleteBillingDiscrimination,
};
